import React from "react";

const Description = () => {
  return (
    <span className="text-gray-600">
      Hola! soy Ingeniero Informatico titulado en Duoc UC, dentro de mis
      habilidades esta ser una persona proactiva, analitica, y lider en equipos
      de trabajo. Actualmente estoy en busca de desafíos, en donde pueda
      desarrollarme de manera más profesional y siempre con las ganas de
      aprender.
    </span>
  );
};

export default Description;
